import { inject, computed } from 'vue'

export function useOptions() {
    const storefront = inject('storefront', {})
    const options = computed(() => storefront.value?.options ?? {})

    return {
        options
    }
}